export default __webpack_public_path__ + "static/media/une (2).73966836.jpg";